import { render, staticRenderFns } from "./download.vue?vue&type=template&id=6ec58586"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports